<template>
    <div>
        <div class="SecondTitle">
            <span>{{ $t("enterOTP.secondTitle") }}</span>
        </div>
        <div>
            <span class="tips">{{ $t("enterOTP.tips") }}</span>
        </div>

        <div style="margin-top: 20px;">
            <input id="otpShadow" ref="cardNo" type="tel" v-model="otpValue" center />
            <van-password-input
                :value="otpValue"
                :gutter="10"
                :mask="false"
                :length="otpValueLength"
                @click="showSystemKeyboard()"
                :focused="showKeyboard"
                @focus="showKeyboard = true"
            />
        </div>

        <div>
            <div v-show="!this.showResendBtn">
                <div class="resend-otp" v-if="this.$root.$i18n.locale == 'en'">
                    <span>{{ $t("enterOTP.resendOTPCountdown") }}</span>
                    <van-count-down style="margin-left: 10px;" ref="timeDown" :time=this.number format="mm:ss" :auto-start="true" @finish="timeDownFinish()" />
                </div>
                <div class="resend-otp" v-if="this.$root.$i18n.locale == 'kr'">
                    <van-count-down style="margin-right: 10px;" ref="timeDown" :time=this.number format="mm:ss" :auto-start="true" @finish="timeDownFinish()" />
                    <span>{{ $t("enterOTP.resendOTPCountdown") }}</span>
                </div>
            </div>
            <van-button :loading="resendLoading" v-show="this.showResendBtn" @click="start()" size="large" round class="button-verify">
                {{ $t("enterOTP.resendOTP") }}
            </van-button>
        </div>

        <van-button
            @click="verifyOtp"
            :disabled="((otpValue.length != otpValueLength) || pageLoading)"
            size="large"
            round
            class="button-verify"
            :loading="loading"
        >{{ $t("enterOTP.verify") }}</van-button>

        <van-dialog v-model="showDialog" :show-confirm-button="false">
            <template v-slot:title>
                <p style="text-align: left">{{ $t("enterOTP.invalidOTP") }}</p>
            </template>
            <template v-slot:default>
                <div>
                    <span>{{ $t("enterOTP.OTPRuleMessage1") }}</span><br>
                    <span>{{ $t("enterOTP.OTPRuleMessage2") }}</span>
                    <van-button
                        style="width: 95%;margin-bottom: 10px"
                        class="button-verify"
                        @click="closeDialog()"
                    >
                        {{
                        $t("enterOTP.ok") }}
                    </van-button>
                </div>
            </template>
        </van-dialog>
    </div>
</template>

<script>
import {
    Dialog,
    PasswordInput,
    NumberKeyboard,
    Switch,
    Cell,
    DropdownMenu,
    DropdownItem,
    Divider,
    Button,
    Field,
    Toast,
} from "vant";
import { generateOtp, verifyOtp } from "@/api/eformApi";
import mixins from "../mixin/Registration.js";
export default {
    name: "EnterOpt",
    mixins: [mixins],
    components: {
        [Dialog.Component.name]: Dialog.Component,
        [NumberKeyboard.name]: NumberKeyboard,
        [PasswordInput.name]: PasswordInput,
        [Switch.name]: Switch,
        [Cell.name]: Cell,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Divider.name]: Divider,
        [Button.name]: Button,
        [Field.name]: Field,
    },
    watch: {
        otpValue() {
            // 非数字替换成空
            this.otpValue = this.otpValue.replace(/[^0-9]/g, "");
            if (this.otpValue.length > this.otpValueLength) {
                this.otpValue = this.otpValue.substring(0, this.otpValueLength);
            }
        },
    },
    created() {
        this.phoneNumber = this.$route.params.phoneNumber
        this.firstName = this.$route.params.firstName
        this.sessionKey = this.$route.params.sessionKey
        this.brandName = this.brandConfig.display;
    },
    data() {
        return {
            showKeyboard: false,
            otpValue: "",
            number: 5 * 60  * 1000,
            time: "",
            showDialog: false,
            phoneNumber: "",
            otpValueLength: 6,
            pageLoading: false,
            brandName: "",
            loading: false,
            resendLoading: false,
            showResendBtn: false,
            firstName: "",
            sessionKey: "",
        };
    },
    methods: {
        timeDownFinish() {
            Toast.fail({
                type: "text",
                message: this.$t("enterOTP.expiredMessage"),
                onClose: () => this.showResendBtn = true,
            });
        },
        closeDialog() {
            this.showDialog = false;
        },
        showSystemKeyboard() {
            this.showKeyboard = true;
            this.$refs.cardNo.focus();
        },
        verifyOtp() {
            this.pageLoading = true;
            this.loading = true;
            verifyOtp({
                storeNo: this.$route.query.storeId,
                brandCode: this.$route.params.brand,
                phoneno: this.phoneNumber,
                authNum: this.otpValue,
                country: this.$route.params.countryPath,
                brandName: this.brandName,
                sessionKey: this.sessionKey
            })
                .then((res) => {
                    if (res.success) {
                        if (res.data == "000") {
                            Toast.success({
                                type: "success",
                                className: 'genWidth',
                                message: this.$t("enterOTP.toastSuccess"),
                            });
                            this.$router.push(
                                {
                                    name: 'Registration',
                                    params: {
                                        lang: this.$route.params.lang,
                                        brand: this.$route.params.brand,
                                        country: this.$route.params.countryPath,
                                        sessionKey: this.sessionKey,
                                        firstName: this.firstName,
                                        phoneNumber: this.phoneNumber,
                                    },
                                    query: {
                                        storeId: this.$route.query.storeId,
                                    }
                                }
                            );
                            this.pageLoading = false;
                            this.loading = false;
                        } else if (res.data == "204") {
                            Toast.fail({
                                type: "text",
                                className: 'noticeWidth',
                                message: this.$t("common.sessionExpired"),
                                onClose: () =>
                                    this.$router.push(
                                        "/" +
                                            this.$route.params.countryPath +
                                            "/" +
                                            this.$route.params.brand +
                                            "/EnterNumber/" +
                                            this.$root.$i18n.locale +
                                            "?storeId=" +
                                            this.$route.query.storeId
                                    ),
                            });
                        } else {
                            Toast.fail({
                                type: "fail",
                                className: 'genWidth',
                                message: this.$t("enterOTP.toastFail"),
                            });
                            this.showDialog = true;
                            this.otpValue = "";
                            this.pageLoading = false;
                            this.loading = false;
                        }
                    } else {
                        Toast.fail({
                            type: "fail",
                            className: 'genWidth',
                            message: this.$t("enterOTP.toastFail"),
                        });
                        this.pageLoading = false;
                        this.loading = false;
                    }
                })
                .catch(() => {
                    Toast.fail({
                        type: "fail",
                        className: 'genWidth',
                        message: this.$t("enterOTP.toastFail"),
                    });
                    this.pageLoading = false;
                    this.loading = false;
                });
        },
        start() {
            this.resendLoading = true;
            generateOtp({
                phoneno: this.phoneNumber,
                country: this.$route.params.countryPath,
                brandName: this.brandName,
                storeNo: this.$route.query.storeId,
                brandCode: this.$route.params.brand,
            }).then((res) => {
                if (res.success) {
                    this.sessionKey = res.data.session_key
                    Toast.success({
                            type: "success",
                            className: 'genWidth',
                            message: this.$t("enterNumber.toastSuccess"),
                        });
                    this.showResendBtn = false;
                    this.$refs.timeDown.reset()
                } else {
                    Toast.fail({
                            type: "fail",
                            className: 'genWidth',
                            message: this.$t("enterNumber.toastFail"),
                        });
                }
                this.resendLoading = false;
            }).catch(() => {
                this.resendLoading = false;
            });
        }
    },
};
</script>

<style scoped>
>>> .van-popup--top {
    width: 25%;
    padding-left: 16px;
}

.button-verify {
    display: inline;
    background: black;
    color: white;
    border-radius: 7px;
    margin-top: 20px;
}

.resend-otp {
    display: ruby-text;
    font-size: 14px;
    text-align: center;
    margin-top: 20px;
    font-family: Helvetica-Regular;
}

.van-password-input__security li {
    background-color: #ececec;
    border-radius: 6px;
}

>>> .van-dialog__header {
    padding-top: 0px;
    margin-left: 5%;
}

>>> .van-dialog__content {
    margin-left: 5%;
}

>>> .van-dialog {
    border-radius: 6px;
}

#otpShadow {
    border-style: none;
    width: 100;
    height: 0;
    padding: 0;
}
</style>

<style>
.noticeWidth {
    width: 100%;
}
.genWidth {
    width: max-content !important;
}
</style>